import MallGroupApi from "@/api/zfb/mall_group";
import categoryApi from "@/views/moving_function/components/mall_category_select2/api";
import { Service_SetGroupIdToLocal } from "@/service/platform_config";

const state = () => ({
  GroupId: null,
  mallGroupList: [],
  mallList: [],
  checkMall: {}, //当前切换到的店铺
  mallCategory: { mainCategory: [] },
});

const getters = {
  GroupId: (state) => state.GroupId,
  mallGroupList: (state) => state.mallGroupList,
  mallList: (state) => state.mallList,
  checkMall: (state) => state.checkMall,
  mallCategory: (state) => state.mallCategory,
};

const mutations = {
  setMallGroup(state, { mallGroupList }) {
    state.mallGroupList = mallGroupList;
  },
  setMallCategory(state, mallCategory) {
    if (state.checkMall && state.checkMall.Id) {
      state.mallCategory[state.checkMall.Id] = mallCategory;
    } else {
      state.mallCategory.mainCategory = mallCategory;
    }
  },
  setMallList(state, mallList) {
    //console.log(state.mallList);
    state.mallList = mallList;
  },
  setCheckMall(state, checkMall) {
    state.checkMall = checkMall;
  },
  setGroupId(state, GroupId) {
    state.GroupId = GroupId;
    Service_SetGroupIdToLocal(GroupId);
  },
};
let getCatLock = false;
const actions = {
  async GetMallGroupList({ commit }) {
    var { msg, success, mallGroupList } = await MallGroupApi.GetMallGroupList();
    commit("setMallGroup", { mallGroupList });
    if (!mallGroupList || mallGroupList.length < 1) {
      commit("setGroupId", "");
    }
    return { msg, success, mallGroupList };
  },
  //获取店铺类目
  //暂时只拿主店类目 把缓存机制先做起来
  async getMallCategory({ state, commit }, isSync) {
    return new Promise((resolve) => {
      const getCatInterval = setInterval(async () => {
        if (!getCatLock) {
          getCatLock = true;
          if (
            //有店群 店铺有缓存则拿店铺缓存
            !isSync &&
            state.checkMall &&
            state.checkMall.Id &&
            state.mallCategory[state.checkMall.Id] &&
            state.mallCategory[state.checkMall.Id].length > 0
          ) {
            getCatLock = false;
            clearInterval(getCatInterval);
            resolve({ list: state.mallCategory[state.checkMall.Id], success: true });
            // return { list: state.mallCategory[state.checkMall.Id], success: true };
          } else {
            if (
              //没有店群拿 mainCate 是当前账号类目
              (!isSync && !state.checkMall && !state.checkMall.Id) ||
              (state.mallCategory.mainCategory && state.mallCategory.mainCategory.length > 0)
            ) {
              getCatLock = false;
              clearInterval(getCatInterval);
              resolve({ list: state.mallCategory.mainCategory, success: true });
              //return { list: state.mallCategory.mainCategory, success: true };
            } else {
              //都没有缓存 或者要同步则
              const { list, msg, success } = await categoryApi.GetGoodsCategoryList(isSync);

              commit("setMallCategory", list);
              getCatLock = false;
              clearInterval(getCatInterval);

              resolve({ list: list, success: success, msg: msg });
              //   return { list: state.mallCategory[state.checkMall.Id], success: success, msg: msg };
            }
          }
        }
      }, 20);
    });
  },
};

export default { state, getters, mutations, actions };
